module.exports = __webpack_public_path__ + "bt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bt.svg
// module id = 468
// module chunks = 0